import React, { Component } from 'react'; //different
//import './style.css';
import jwt_decode from "jwt-decode";
import instance from "./axios-instance";
import Swal from 'sweetalert2'
import Systems from "./SystemFunction";
import { json } from 'react-router-dom';
import { LoopTwoTone } from '@mui/icons-material';
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
let isMobile = false;
if (window.innerWidth <= 760) isMobile = true;
class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            mainsetting: [],
            tabselect: 1,
            rewardlist: [],
            activePage: 1,
            pagecount: 1,
            tblbank: [],
            item: null,
            acceptterm: false,
            loadinbutton: true,
            showbankError: false,
            showbankAccountError: false,
            showbankAccountErrorWrong: false,
            showbankAccountNameError: false,
            openbank: false,
            products_page_count: 1,
            isActive: false,
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            loading: false, // Indicates in progress state of login form
            stateopterror: "",
            stateregis: 1,
            showpass: true,
            showpasswordError: false,
            showcpasswordError: false,
            lang: window.localStorage.getItem("lang"),
            bankselect: 0,
            trueaccount: true,
            checkname: false,
            username: null,
            rawDigits: "",      // เก็บเลขล้วน
            formatted: "",      // เวอร์ชันมี "-"
            fname: "",
            logoimg: "",
            checkboxacc: 0,
            userid: null,
            phoneNumber: "",
            userrecomend: "",
            linelink: "",
            balance: 0,
            mainacc: null,
            dropdownVisible: false, // ควบคุมการแสดง dropdown
            password: "",
            confirmPassword: "",
            showPassword: false,   // ถ้าต้องการให้แสดงเป็น text เริ่มต้น = true หรือ false ตามต้องการ
            showConfirm: false,   // หรือ true ตาม UX ที่ต้องการ
            touched: { password: false, confirmPassword: false, phone: false, bankAccount: false, bankAccountName: false },
            submitted: false,
            selectedBank: {}, // เก็บข้อมูลธนาคารที่เลือก

        }
        this.forgetotpandregister = this.forgetotpandregister.bind(this);
    }
    notify = async (mode, msg) => {
        console.log(mode, msg);
        if (mode == "success") {
            await toast.success(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "warning") {
            await toast.warning(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "error") {
            await toast.error(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "info") {
            await toast.info(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
    }

    formatThaiNumber = (digits) => {
        if (!digits) return "";
        if (digits.length <= 3) return digits;
        if (digits.length <= 6) return digits.replace(/(\d{3})(\d+)/, "$1-$2");
        return digits.replace(/(\d{3})(\d{3})(\d{0,4})/, (_, a, b, c) =>
            c ? `${a}-${b}-${c}` : `${a}-${b}`
        );
    };
    nexttap = (e) => {
        if (this.isValid()) {
            this.setState({ tabselect: 2 });
        }
    };
    handleChange = (e) => {
        const onlyDigits = e.target.value.replace(/\D/g, "").slice(0, 10);
        this.setState({
            rawDigits: onlyDigits,
            phoneNumber: onlyDigits,
            formatted: this.formatThaiNumber(onlyDigits),
            touched: true
        });
    };

    handleBlur = () => {
        this.setState({ touched: true });
    };

    // เช็คเบอร์ถูกต้องหรือยัง
    isValid = () => {
        return /^0\d{9}$/.test(this.state.rawDigits);
    };
    confirmdeposit = async (e, num) => {

        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;

        await instance.post("/api/v1/getredeempromotion", {
            userid: Username,
            System: Systems,
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
            if (res.data.status === 200) {
                this.setState({
                    proderedeem: res.data.message.tblpromotionredeems,
                });

            }
        }).catch(async (err) => {
        });

        if (num === 0) {
            if ((this.state.depositamount >= this.state.limit.min) && (this.state.depositamount <= this.state.limit.max)) {
                const { depositstate } = this.state
                ////////console.log(depositstate, num);
                if (num === 0) {
                    if (token != null) {
                        instance.post("/api/v1/getqrcode", {
                            username: Username,
                            System: Systems,
                            amount: this.state.depositamount
                        }, {
                            headers: { Authorization: `Bearer ${token}` }
                        }).then(async (res) => {
                            ////////console.log(res.data.picture)
                            this.setState({
                                mainacc: res.data.mainacc,
                                qrcode: res.data.picture
                            });
                        });
                    }

                    this.setState({
                        depositstate: 1
                    });
                }
            }
            else {
                await Swal.fire({
                    title: 'Warning!',
                    text: 'เติมขั้นต่ำ ' + this.state.limit.min + ' บาท สูงสุด ' + this.state.limit.max + ' ',
                    icon: 'warning',
                    confirmButtonText: 'ตกลง'
                })
            }
        }
        else if (num === 1) {
            this.setState({
                depositstate: 1
            });
        }
        else {
            this.setState({
                depositstate: 0
            });
        }



    }
    radiocheck(input, listitem) {
        console.log(input);
        this.setState({
            bankselect: input,
            item: listitem,
            openbank: false
        });
        if (input == 99) {
            this.setState({
                trueaccount: false
            });
        }
        else {
            this.setState({
                trueaccount: true,
                fname: ""
            });
        }
    }
    forgetotpandregister = async (type) => {
        console.log("forgetotpandregister called with type:", type);
        const { phoneNumber, otpphoneforget, bankselect, bankAccount, otpphone } = this.state;
        var recheck = false;
        if (type === 6) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;
            });
        }
        else if (type === 10) {
            console.log("Requesting OTP for registration with phone number:", phoneNumber);
            return await instance.post("/api/v1/resetpassword", {
                accountnumber: bankAccount,
                bankid: bankselect,
                System: Systems,
                type: type
            }).then(async (res) => {
                console.log(res.data.message);
                return recheck = res.data.message;

            }).catch(async (err) => {
                console.log(err);
            });
        }
        return recheck
    }
    toggleDropdown = () => {
        this.setState((prevState) => ({ dropdownVisible: !prevState.dropdownVisible }));
    };

    // เลือกธนาคาร
    handleSelectBank = (bank) => {
        this.setState({ selectedBank: bank, dropdownVisible: false });
        console.log("ธนาคารที่เลือก:", bank); // สามารถนำไปใช้งานต่อได้
    };

    // เพิ่มฟังก์ชันตรวจชื่อบัญชี (ชื่อ เว้นวรรค นามสกุล)
    // ใช้ได้ตรง ๆ ใน class component ของคุณ
    validateBankAccountName = (name) => {
        if (!name || name.trim().length === 0) return "required";

        // normalize: NBSP + ช่องว่างซ้ำ + อักขระแฝง
        let normalized = name
            .replace(/[\u200B-\u200D\uFEFF]/g, "") // zero-width chars
            .replace(/\u00A0/g, " ")
            .trim()
            .replace(/\s+/g, " ");

        // ตัดคำนำหน้าที่พบบ่อย (รองรับมี/ไม่มีจุด)
        normalized = normalized.replace(
            /^(นาย|นางสาว|น\.ส\.?|นาง|ด\.ช\.?|ด\.ญ\.?|เด็กชาย|เด็กหญิง|คุณ|Mr\.?|Mrs\.?|Ms\.?)\s*/iu,
            ""
        );

        const parts = normalized.split(" ").filter(Boolean);
        if (parts.length < 2) return "กรุณาระบุ ชื่อ และ นามสกุล (คั่นด้วยเว้นวรรค)";

        // ตัวอักษรไทย/อังกฤษ (รวมวรรณยุกต์/สระ) เท่านั้น
        let pattern;
        try {
            pattern = new RegExp("^[\\p{L}\\p{M}]+$", "u");
        } catch (err) {
            pattern = /^[\u0E00-\u0E7Fa-zA-Z]+$/;
        }

        for (let p of parts) {
            if (!pattern.test(p)) {
                return "ชื่อ/นามสกุลต้องเป็นตัวอักษรเท่านั้น (ไม่มีตัวเลขหรือสัญลักษณ์)";
            }
            if (p.length < 2) {
                return "แต่ละคำ (ชื่อ/นามสกุล) ควรยาวอย่างน้อย 2 ตัวอักษร";
            }
        }

        return ""; // ผ่าน
    };




    nextstep = async (e, num) => {
        e.preventDefault();
        const { phoneNumber } = this.state;
        let bankAccountName = this.state.bankAccountName;
        let cehckedxx = false;
        if (num === 26) {
            let check = await this.forgetotpandregister(10)
            console.log("Result from forgetotpandregister:", check,bankAccountName);
            if (phoneNumber.length !== 10 && !check.checked) {
                if (phoneNumber.length !== 10) {
                    await this.notify("warning", "คุณใส่เบอร์ผิดพลาด");
                } else if (!check.checked && check.status === 201) {
                    await this.notify("warning", "เบอร์นี้มีคนใช้แล้ว");
                } else {
                    await this.notify("warning", "คุณทำรายการถี่เกินไป โปรดรอซักครู่");
                    this.setState({ stateopterror: "คุณทำรายการถี่เกินไป โปรดรอซักครู่" });
                }
                return;
            }
            if (!check.checked) {
                console.log("Setting showbankAccountErrorWrong to true");
                this.setState({ showbankAccountErrorWrong: true, acceptterm: !this.state.acceptterm });
                return;
            }
            else  {

                if (check.verifications.status === 0 && bankAccountName === '' || bankAccountName === null || bankAccountName === undefined) {
                    this.setState({
                        trueaccount: false,
                        acceptterm: !this.state.acceptterm
                    });
                   return;
                }
                else if (check.verifications.status === 1) {
                    bankAccountName = check.verifications.name
                    cehckedxx = true;
                    this.setState({
                        bankAccountName: check.verifications.name,

                    });
                }
            }
            console.log("nextstep called with :", check);
            // ถ้าผ่านการเช็คเบอร์ -> ไปตรวจชื่อบัญชีและเรียกฟังก์ชันสมัคร
            this.setState({ loading: true, loadinbutton: false });
            try {

                const nameErr = this.validateBankAccountName(bankAccountName);
                console.log('normalized:', bankAccountName.replace(/\u00A0/g, ' ').trim().replace(/\s+/g, ' '));
                console.log('validate:', nameErr);
                if (nameErr !== "") {
                    await this.notify("warning", nameErr);
                    return;
                }
                // เรียกฟังก์ชันสมัคร (ส่งชื่อบัญชีเป็น param)
                await this.validatergisterForm(bankAccountName);

            } finally {
                this.setState({ loading: false });
            }
        }
    };

    validatergisterForm = async (fname) => {
        // ไม่ต้องรับ event ที่นี่อีก (เรียกจาก nextstep)
        const { phoneNumber, selectedBank, password, bankselect, bankAccountName, bankAccount } = this.state;

        console.log("validatergisterForm called with :", { phoneNumber, selectedBank, password, bankselect, bankAccountName });
        this.setState({ stateregis: 4 });
        // ตรวจชื่อบัญชี (double-check)
        const nameErr = this.validateBankAccountName(fname);
        if (nameErr !== "") {
            await this.notify("warning", nameErr);
            this.setState({ stateregis: 2 });
            return;
        }
        // เรียก API
        try {
            const payload = {
                User_id: phoneNumber,
                name: fname.trim(),
                password: password,
                accbank: bankselect,
                accno: bankAccount.trim(),
                System: Systems,
                Useradvise: this.state.userrecomend
            };

            const res = await instance.post("/api/v1/register", payload);
            console.log(res.data);

            if (res.data.status === 200) {
                this.setState({ stateregis: 3 });
                // login อัตโนมัติ
                const loginRes = await instance.post("/api/v1/userlogin", {
                    userid: phoneNumber,
                    password,
                    System: Systems,
                    Function: "validateLoginForm-navbar.js"
                });

                if (loginRes.data.status === 200) {
                    localStorage.setItem("auth_token", loginRes.data.token);

                    // redirect
                    await this.modalerror({ title: "success", text: "คุณสมัครเรียบร้อย จะทำการ login Auto" });
                    setTimeout(() => (window.location.href = "/home"), 1500);
                } else {
                    this.setState({ stateregis: 2, loadinbutton: true });
                    await this.modalerror({ title: "error", text: "โปรดตรวจสอบข้อมูลอีกครั้ง" });
                }
            } else if (res.data.status === 203) {
                this.setState({ stateregis: 2, loadinbutton: true });
                await this.modalerror({ title: "error", text: "เลขบัญชี นี้ทำการสมัครไปแล้ว" });
            } else if (res.data.status === 202) {
                this.setState({ stateregis: 2, loadinbutton: true });
                await this.modalerror({ title: "error", text: "Username นี้ทำการสมัครไปแล้ว" });
            } else {
                this.setState({ stateregis: 2, loadinbutton: true });
                await this.modalerror({ title: "error", text: "Username หรือ ชื่อในการสมัครไม่ถูกต้อง" });
            }
        } catch (err) {
            console.error(err);
            await this.modalerror({ title: "error", text: "เกิดข้อผิดพลาดจากเซิร์ฟเวอร์ โปรดลองใหม่" });
            this.setState({ stateregis: 2, loadinbutton: true });
        }
    };


    //     nextstep = async (e, num) => {
    //         e.preventDefault();
    //         const { phoneNumber, bankAccountName } = this.state

    //         if (num === 26) {
    //             const check = await this.forgetotpandregister(6);

    //             if (phoneNumber.length !== 10 && !check.checked) {
    //                 if (phoneNumber.length !== 10) {
    //                     await this.notify("warning", 'คุณใส่เบอร์ผิดพลาด');
    //                 }
    //                 else if (!check.checked && check.status === 201) {
    //                     await this.notify("warning", 'เบอร์นี้มีคนใช้แล้ว');
    //                 }
    //                 else {
    //                     await this.notify("warning", 'คุณทำรายการถี่เกินไป โปรดรอซักครู่');
    //                     this.setState({
    //                         stateopterror: "คุณทำรายการถี่เกินไป โปรดรอซักครู่"
    //                     });
    //                 }
    //             }
    //             else {
    //                 this.setState({
    //                     loading: true,
    //                 });
    //                 if (bankAccountName !== '') {
    //                     await this.validatergisterForm(e, bankAccountName)
    //                 }
    //                 else {
    //                     await this.notify("warning", 'ทำรายการไม่สำเร็จ');
    //                 }
    //                 this.setState({
    //                     loading: false,
    //                 });
    //             }



    //         }
    //     };
    //   validatergisterForm = async (e, fname) => {
    //         e.preventDefault();
    //         const { phoneNumber, selectedBank, password, passwordcf, bankselect, accnumbertxt } = this.state;
    //         this.setState({
    //             stateregis: 4
    //         });
    //         if (password.length > 15) {
    //             var title = 'error'
    //             var text = 'พาสเวิดสูงสุดไม่เกิน 15 ตัว'
    //             var object = { title, text }
    //             this.modalerror(object);
    //         }
    //         else if (password.length < 6) {
    //             var title = 'error'
    //             var text = 'พาสเวิดต่ำไม่เกิน 15 ตัว'
    //             var object = { title, text }
    //             this.modalerror(object);
    //         }
    //         else {

    //             await instance.post("/api/v1/register", {
    //                 User_id: phoneNumber,
    //                 name: fname,
    //                 password: password,
    //                 accbank: selectedBank.id,
    //                 accno: accnumbertxt,
    //                 System: Systems,
    //                 Useradvise: this.state.userrecomend
    //             }).then(async (res) => {
    //                 console.log(res.data);
    //                 if (res.data.status === 200) {
    //                     this.setState({ stateregis: 3 });
    //                     await instance.post("/api/v1/userlogin", {
    //                         userid: phoneNumber,
    //                         password: password,
    //                         System: Systems,
    //                         Function: 'validateLoginForm-navbar.js'
    //                     }).then((res) => {
    //                         console.log(res.data);
    //                         if (res.data.status === 200) {
    //                             this.setState({
    //                                 stateregis: 3
    //                             });
    //                             localStorage.setItem('auth_token', res.data.token);
    //                             setInterval(() =>
    //                                 window.location.href = '/home'
    //                                 , 1500);

    //                         }
    //                         else {
    //                             this.setState({
    //                                 stateregis: 2
    //                             });
    //                             var title = 'error'
    //                             var text = 'โปรดตรวจสอบข้อมูลอีกครั้ง'
    //                             var object = { title, text }
    //                             this.modalerror(object);
    //                         }
    //                     });
    //                 }
    //                 else if (res.data.status === 203) {
    //                     this.setState({
    //                         stateregis: 2
    //                     });
    //                     var title = 'error'
    //                     var text = 'เลขบัญชี นี้ทำการสมัครไปแล้ว'
    //                     var object = { title, text }
    //                     this.modalerror(object);
    //                 }
    //                 else if (res.data.status === 202) {
    //                     this.setState({
    //                         stateregis: 2
    //                     });
    //                     var title = 'error'
    //                     var text = 'Username นี้ทำการสมัครไปแล้ว'
    //                     var object = { title, text }
    //                     this.modalerror(object);
    //                 }
    //                 else {
    //                     this.setState({
    //                         stateregis: 2
    //                     });
    //                     var title = 'error'
    //                     var text = 'Username หรือ ชื่อในการสมัครไม่ถูกต้อง'
    //                     var object = { title, text }
    //                     this.modalerror(object);
    //                 }
    //             });
    //         }


    //     };
    onChangex = event => {
        // console.log("event", event.target.name);


        if (event.target !== undefined) {
            let nam;
            let val;
            if (event.target.name === "otpphone") {
                document.getElementById("otpphone").style = "";
                document.getElementById("checkotp").style.display = "none";
            }
            else if (event.target.name === "otpphoneforget") {
                document.getElementById("otpphoneforget").style = "";
                document.getElementById("checkotpforget").style.display = "none";
            }
            else if (event.target.name === "otpphoneforget") {
                document.getElementById("phoneNumber").style = "";
                document.getElementById("checkotpforgetphonenormal").style.display = "none";
            }

            if (event.target.name === undefined) {
                nam = event.name;
                val = event.value;
            } else {
                nam = event.target.name;
                val = event.target.value;
            }
            this.setState({ [nam]: val });
        }
    };
    async modalerror(object) {
        // await Swal.fire({
        //     title: object.title + "!",
        //     text: object.text,
        //     icon: object.title,
        //     confirmButtonText: 'ตกลง'
        // })
        await this.notify(object.title, object.text);
    }

    changepass = (e) => {
        e.preventDefault();
        this.setState({
            showpass: this.state.showpass ? false : true,
        });
    }
    async saveclickaff(linkid) {
        await instance.post("/api/v1/saveclickaff", {
            linkid: linkid,
            System: Systems,
        }).then((res) => {
            if (res.data.status == 200) {
                var date = new Date()
                this.setState({
                    userrecomend: res.data.username,
                    link: linkid
                });
                var username = res.data.username
                var object = { date, username }
                localStorage.setItem('aff', JSON.stringify(object))
            }
        }).catch(async (err) => {
        });

    }
    async saveclick(linkid) {
        await instance.post("/api/v1/saveclickaff", {
            linkid: linkid,
            System: Systems,
        }).then((res) => {
            if (res.data.status == 200) {
                var date = new Date()
                var username = res.data.username
                this.setState({
                    userrecomend: username,
                });
                var object = { date, username }
                localStorage.setItem('aff', JSON.stringify(object))
            }
        }).catch(async (err) => {
        });

    }
    async componentDidMount() {
        // var token = localStorage.getItem('auth_token');
        // if (token != null) {
        //     localStorage.removeItem('auth_token', '')
        // }
        document.body.className = "";
        document.body.style = "background-color:black"
        document.documentElement.className = "scroll-smooth";
        this.link = document.createElement('link');
        this.link.rel = 'stylesheet';
        this.link.href = './login.css'; // Path to your CSS
        document.head.appendChild(this.link);

        const search = window.location.href;
        var test = search.split("aff=")[1]
        if (test != undefined) {
            this.saveclickaff(test.split("&")[0]);
        }
        var params = search.split("reg=")[1]
        if (params != undefined) {
            this.saveclick(params);
            this.setState({
                userrecomend: params.split("&")[0],
            });
        }

        var tokenf = localStorage.getItem('aff');
        if (tokenf != null) {
            var codev = JSON.parse(tokenf)
            //   console.log(codev);
            var Username = codev.username;
            this.setState({
                userrecomend: Username,
            });
        }

        var tokenx = localStorage.getItem('register');
        if (tokenx != null) {
            var codev = JSON.parse(tokenx)
            // console.log(codev);
            var Username = codev.username;
            this.setState({
                userrecomend: Username,
            });
        }


        await instance.post("/api/v1/mainsetting", {
            System: Systems,
        }).then((res) => {
            if (res.data.status === 200) {

                const datas = res.data.message;
                var min = res.data.tblcatagoryx[0].limitdeposit;
                var max = res.data.tblcatagoryx[0].maxdeposit;
                var limit = { min, max }
                const link3 = document.querySelector("link[rel*='icon']") || document.createElement('link');
                link3.type = 'image/svg+xml';
                link3.rel = 'icon';
                link3.href = res.data.tblsetting[0].imglogo;
                document.getElementsByTagName('head')[0].appendChild(link3);
                this.setState({
                    webname: res.data.tblsetting[0].Description,
                    logoimg: res.data.tblsetting[0].imglogo,
                    linelink: datas[1].value,
                    tblbank: res.data.tblbank,
                    System: res.data.tblcatagoryx[0].System,
                    limit: limit
                });
            }
            else {
                // this.CheckThisGoalError();
            }
        });
        //  this.nameInput.focus();
    }

    isBankAccountValid = (val) => {
        // ตัวอย่าง: ตรวจให้เป็นตัวเลข 10-12 ตัว (ปรับตามต้องการ)
        if (!val) return false;
        return /^\d{10,12}$/.test(val);
    };

    isBankAccountNameValid = (val) => {
        // ตัวอย่าง: ต้องมีอย่างน้อย 3 ตัว และมีช่องวรรค (ชื่อ + นามสกุล)
        if (!val) return false;
        return /^.{3,}\s+.+$/.test(val);
    };

    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    handleFieldBlur = (field) => () => {
        this.setState((s) => ({ touched: { ...s.touched, [field]: true } }));
    };

    validatePassword = (pwd) => {
        if (!pwd || pwd.length === 0) return "required";
        // กฎ: ตัวอักษรอังกฤษ + ตัวเลข อย่างน้อย 8 ตัว
        const rule = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
        return rule.test(pwd) ? "" : "ใช้อักขระภาษาอังกฤษและตัวเลข 8 หลักขึ้นไป";
    };

    // ฟังก์ชันตรวจยืนยันรหัสผ่าน
    validateConfirm = (pwd, confirm) => {
        if (!confirm || confirm.length === 0) return "required";
        if (pwd !== confirm) return "ยืนยันรหัสผ่านไม่ถูกต้อง";
        return "";
    };

    // ตรวจรวม (enable submit)
    allValid = () => {
        const { password, confirmPassword, bankAccount, bankAccountName, bankselect } = this.state;
        const pErr = this.validatePassword(password);
        const cErr = this.validateConfirm(password, confirmPassword);
        const bankOk = bankselect != null && (bankAccount || "").trim().length > 0 && (bankAccountName || "").trim().length > 0;
        return pErr === "" && cErr === "" && bankOk;
    };


    isvalidateALL = () => {
        const { password, confirmPassword, bankAccount, bankAccountName, bankselect } = this.state;

        const pErr = this.validatePassword(password);
        const cErr = this.validateConfirm(password, confirmPassword);
        const bankOk = bankselect != null && bankselect !== 0;
        const bankAccountA = (bankAccount || "").trim().length > 0;
        const bankAccountNameA = (bankAccountName || "").trim().length > 0;


        const valid = pErr === "" && cErr === "" && bankOk;
        if (valid) {
            this.setState({ showterm: true });
        }
        else {
            console.log("pErr,cErr,bankOk", { pErr, cErr, bankOk, bankselect, bankAccount });
            if (pErr === "" || pErr === "required") this.setState((s) => ({ showpasswordError: true }));
            if (cErr === "" || cErr === "required") this.setState((s) => ({ showcpasswordError: true }));
            if (!bankOk) this.setState((s) => ({ showbankError: true }));
            if (!bankAccountA) this.setState((s) => ({ showbankAccountError: true }));
            if (!bankAccountNameA) this.setState((s) => ({ showbankAccountNameError: true }));
        }

    };
    // handlers
    handlePasswordChange = (e) => {
        this.setState({ password: e.target.value, showpasswordError: false });
    };
    handleConfirmChange = (e) => {
        this.setState({ confirmPassword: e.target.value, showcpasswordError: false });
    };

    // onBlur helper (ใช้แบบ onBlur={this.handleBlur('password')})
    handleBlur = (field) => () => {
        this.setState((s) => ({ touched: { ...s.touched, [field]: true } }));
    };

    toggleShowPassword = () => this.setState(s => ({ showPassword: !s.showPassword }));
    toggleShowConfirm = () => this.setState(s => ({ showConfirm: !s.showConfirm }));

    render() {
        const { rawDigits, formatted, showbankError, showbankAccountErrorWrong, touched, tabselect, tblbank, bankselect, openbank, item, acceptterm, loadinbutton, showpasswordError, showcpasswordError } = this.state;
        const { password, confirmPassword, submitted } = this.state;
        const { bankAccount, bankAccountName, showPassword, showConfirm } = this.state;

        const pValidationText = this.validatePassword(password);
        const cValidationText = this.validateConfirm(password, confirmPassword);

        const showPwdError = (touched.password || submitted) && pValidationText !== "" && pValidationText !== "required" || showpasswordError;
        const showConfirmError = (touched.confirmPassword || submitted) && cValidationText !== "" && cValidationText !== "required" || showcpasswordError;
        const showPwdRequired = (touched.password || submitted) && pValidationText === "required";
        const showConfirmRequired = (touched.confirmPassword || submitted) && cValidationText === "required";


        const showbankAccountError = (touched.bankAccount || submitted) && !this.isBankAccountValid(bankAccount) || this.state.showbankAccountError;;
        const showbankAccountNameError = (touched.bankAccountName || submitted) && !this.isBankAccountNameValid(bankAccountName) || this.state.showbankAccountNameError;;


        const canSubmit = this.allValid();
        // กำหนด class by state
        let wrapperClass = "Register_borderNone__jszpp";
        if (rawDigits.length > 0) {
            wrapperClass = this.isValid()
                ? "Register_borderSuccess__Eo9K_"
                : "Register_borderError___Afsj";
        }


        //   console.log("showerr", { showPwdError, showConfirmError, showpasswordError, showcpasswordError })
        return (
            <>
                <div className={isMobile ? "css-14pm9ft" : "css-bar7n8"}>
                    <div className="flex-1 flex flex-col bg-black font-NotoSans text-white overflow-hidden w-[428px] mx-auto">
                        <div className="relative flex flex-col flex-1 bg-[#101010] z-0 overflow-hidden">
                            <header className="w-full h-[50px] z-50 bg-black">
                                <div className="w-full h-[50px] flex flex-row justify-between items-stretch px-3 xs:px5">
                                    <div className="h-[50px] flex items-center cursor-pointer">
                                        <div className="relative w-[100px] sm:w-[139px] h-[32px]" >
                                            <a href="https://savia88.com/">
                                                <span

                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "absolute",
                                                        inset: 0
                                                    }}
                                                >
                                                    <img
                                                        alt="logo"
                                                        src={this.state.logoimg}
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain"
                                                        }}
                                                    />
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                    <div className="flex items-center">
                                        <ul className="w-full h-full flex flex-row justify-center items-stretch gap-2">
                                            <li
                                                className="h-full flex flex-col justify-center"
                                                style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                            >
                                                <a
                                                    className="px-2 xs:px-3 py-1.5 rounded-lg text-xs text-center text-[#FEB723] border border-[#D5C5A1]"
                                                    href="/login"
                                                >
                                                    เข้าสู่ระบบ
                                                </a>
                                            </li>
                                            <li className="flex flex-col justify-center items-center">
                                                <div
                                                    className="flex justify-center items-center text-right z-50"
                                                    style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                                >
                                                    <div
                                                        className="relative inline-block text-left"
                                                        data-headlessui-state=""
                                                    >
                                                        <div>
                                                            <button
                                                                className="w-full flex justify-center items-center gap-1 px-1 h-[30px] border"
                                                                id="headlessui-menu-button-:r0:"
                                                                type="button"
                                                                aria-haspopup="menu"
                                                                aria-expanded="false"
                                                                data-headlessui-state=""
                                                                style={{
                                                                    borderColor: "rgb(213, 197, 161)",
                                                                    borderRadius: 8
                                                                }}
                                                            >
                                                                <div
                                                                    className="relative w-[20px] h-[20px] rounded-full border"
                                                                    style={{ filter: "hue-rotate(-191deg)" }}
                                                                >
                                                                    <span
                                                                        style={{
                                                                            boxSizing: "border-box",
                                                                            display: "block",
                                                                            overflow: "hidden",
                                                                            width: "initial",
                                                                            height: "initial",
                                                                            background: "none",
                                                                            opacity: 1,
                                                                            border: 0,
                                                                            margin: 0,
                                                                            padding: 0,
                                                                            position: "absolute",
                                                                            inset: 0
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src="https://play.aroms168.win/images/flags/th.svg"
                                                                            decoding="async"
                                                                            data-nimg="fill"
                                                                            className="rounded-full"
                                                                            style={{
                                                                                maxWidth: "100%",
                                                                                maxHeight: "100%",
                                                                                position: "absolute",
                                                                                inset: 0,
                                                                                boxSizing: "border-box",
                                                                                padding: 0,
                                                                                border: "none",
                                                                                margin: "auto",
                                                                                display: "block",
                                                                                width: 0,
                                                                                height: 0,
                                                                                minWidth: "100%",
                                                                                minHeight: "100%",
                                                                                objectFit: "cover"
                                                                            }}
                                                                        />
                                                                    </span>
                                                                </div>
                                                                <div className="transition-all duration-[0.5s]">
                                                                    <svg
                                                                        className="w-[18px] h-[18px] text-gray-300"
                                                                        aria-hidden="true"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        viewBox="0 0 24 24"
                                                                        fill="currentColor"
                                                                    >
                                                                        <path
                                                                            fillRule="evenodd"
                                                                            d="M12.53 16.28a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 14.69l6.97-6.97a.75.75 0 111.06 1.06l-7.5 7.5z"
                                                                            clipRule="evenodd"
                                                                        />
                                                                    </svg>
                                                                </div>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div
                                    className="z-0 w-full h-[1px] bg-[#F6A32F]"
                                    style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                />
                                <div />
                            </header>
                            <main className="flex-1 overflow-y-auto flex flex-col justify-start no-scrollbar pb-24 z-40" style={{ display: tabselect == 1 ? "" : "none" }}>
                                <div className="max-w-md w-full min-h-full mx-auto pt-2 flex flex-col justify-start items-center gap-2 bg-[#101010]">
                                    <div className="w-full h-[48px] flex items-center px-2 py-3">
                                        <div>
                                            <button className="flex items-center" onClick={() => window.location.href = '/login'} type="button">
                                                <div className="  relative w-[32px] h-[32px] md:w-[36px] md:h-[36px] ">
                                                    <span
                                                        style={{
                                                            boxSizing: "border-box",
                                                            display: "block",
                                                            overflow: "hidden",
                                                            width: "initial",
                                                            height: "initial",
                                                            background: "none",
                                                            opacity: 1,
                                                            border: 0,
                                                            margin: 0,
                                                            padding: 0,
                                                            position: "absolute",
                                                            inset: 0
                                                        }}
                                                    >
                                                        <img
                                                            src="https://cdn.javisx.com/image/ae802067-2071-48bb-b11d-c18d31a2b396.png"
                                                            decoding="async"
                                                            data-nimg="fill"
                                                            style={{
                                                                filter: "hue-rotate(191deg) brightness(1)",
                                                                position: "absolute",
                                                                inset: 0,
                                                                boxSizing: "border-box",
                                                                padding: 0,
                                                                border: "none",
                                                                margin: "auto",
                                                                display: "block",
                                                                width: 0,
                                                                height: 0,
                                                                minWidth: "100%",
                                                                maxWidth: "100%",
                                                                minHeight: "100%",
                                                                maxHeight: "100%"
                                                            }}
                                                        />
                                                    </span>
                                                </div>
                                            </button>
                                        </div>
                                        <div className="flex-grow text-center mr-8 font-bold text-[17px] md:text-[25px] leading-[21px]">
                                            ยืนยันสมัครสมาชิก
                                        </div>
                                    </div>
                                    <div className="w-full px-3 pt-2">
                                        <div>
                                            <div
                                                className="w-full flex flex-col gap-2"
                                                style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                            >
                                                <div className="w-full relative z-0 flex flex-row justify-around">
                                                    <span className="w-8 h-8 relative z-10 flex justify-center items-center font-semibold text-base border text-white border-[#EE5F28] bg-[#EE5F28] rounded-full">
                                                        1
                                                    </span>
                                                    <span className="w-8 h-8 relative z-10 flex justify-center items-center font-semibold text-base border rounded-full text-[#757575] border-[#757575] bg-black">
                                                        2
                                                    </span>
                                                    <div className="w-3/6 h-0.5 absolute z-0 top-[50%] bg-[#757575]" />
                                                </div>
                                                <div className="w-full relative z-0 flex flex-row justify-around">
                                                    <span className="w-full flex justify-center items-center text-white text-[0.6rem] xs:text-xs font-normal">
                                                        กรอกเบอร์โทรศัพท์
                                                    </span>
                                                    <span className="w-full flex justify-center items-center text-center text-[0.6rem] xs:text-xs font-normal text-[#757575]">
                                                        สร้างบัญชีผู้ใช้งานข้อมูลธนาคาร
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <form>
                                            <div className="flex flex-col gap-6 bg-[#161616] border-[#24221E] border border-solid rounded-lg px-3 py-3">
                                                <div className="w-full">
                                                    <div className={wrapperClass}>
                                                        <label
                                                            className="h-[20px] font-[500] text-[0.6rem] xs:text-xs leading-[19px] text-transparent bg-clip-text bg-gradient-to-b from-[#E1D4B4] to-[#B7A47C]"
                                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                                        >
                                                            กรอกเบอร์โทรศัพท์ของท่าน
                                                        </label>

                                                        <div className="w-full flex items-center">
                                                            <input
                                                                name="phoneNumber"
                                                                placeholder="กรอกเบอร์โทรศัพท์ของท่าน"
                                                                autoComplete="off"
                                                                type="tel"
                                                                value={formatted}
                                                                onChange={this.handleChange}
                                                                onBlur={this.handleBlur}
                                                                className="flex-grow font-medium text-sm xs:text-lg placeholder:text-xs xs:placeholder:text-sm leading-[14px] bg-transparent placeholder-[#757575] bg-[#100F12] focus:outline-0"
                                                            />
                                                            <span className="flex items-center">
                                                                <span style={{
                                                                    boxSizing: "border-box",
                                                                    display: touched && !this.isValid() && rawDigits.length > 0 ? "inline-block" : " none",
                                                                    overflow: "hidden",
                                                                    width: "initial",
                                                                    height: "initial",
                                                                    background: "none",
                                                                    opacity: 1,
                                                                    border: 0,
                                                                    margin: 0,
                                                                    padding: 0,
                                                                    position: "relative",
                                                                    maxWidth: "100%"
                                                                }}
                                                                >
                                                                    <span
                                                                        style={{
                                                                            boxSizing: "border-box",
                                                                            display: "block",
                                                                            width: "initial",
                                                                            height: "initial",
                                                                            background: "none",
                                                                            opacity: 1,
                                                                            border: 0,
                                                                            margin: 0,
                                                                            padding: 0,
                                                                            maxWidth: "100%"
                                                                        }}
                                                                    >
                                                                        <img
                                                                            alt=""
                                                                            aria-hidden="true"
                                                                            src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2716%27%20height=%2716%27/%3e"
                                                                            style={{
                                                                                display: "block",
                                                                                maxWidth: "100%",
                                                                                width: "initial",
                                                                                height: "initial",
                                                                                background: "none",
                                                                                opacity: 1,
                                                                                border: 0,
                                                                                margin: 0,
                                                                                padding: 0
                                                                            }}
                                                                        />
                                                                    </span>
                                                                    <img
                                                                        alt=""
                                                                        src="https://cdn.javisx.com/image/3b414bff-75a7-4c24-b4f6-358229e501d8.png"
                                                                        decoding="async"
                                                                        data-nimg="intrinsic"
                                                                        style={{
                                                                            position: "absolute",
                                                                            inset: 0,
                                                                            boxSizing: "border-box",
                                                                            padding: 0,
                                                                            border: "none",
                                                                            margin: "auto",
                                                                            display: "block",
                                                                            width: 0,
                                                                            height: 0,
                                                                            minWidth: "100%",
                                                                            maxWidth: "100%",
                                                                            minHeight: "100%",
                                                                            maxHeight: "100%"
                                                                        }}
                                                                    />
                                                                </span>
                                                                <span
                                                                    style={{
                                                                        boxSizing: "border-box",
                                                                        display: touched && this.isValid() && rawDigits.length > 0 ? "inline-block" : " none",
                                                                        overflow: "hidden",
                                                                        width: "initial",
                                                                        height: "initial",
                                                                        background: "none",
                                                                        opacity: 1,
                                                                        border: 0,
                                                                        margin: 0,
                                                                        padding: 0,
                                                                        position: "relative",
                                                                        maxWidth: "100%"
                                                                    }}
                                                                >
                                                                    <span
                                                                        style={{
                                                                            boxSizing: "border-box",
                                                                            display: "block",
                                                                            width: "initial",
                                                                            height: "initial",
                                                                            background: "none",
                                                                            opacity: 1,
                                                                            border: 0,
                                                                            margin: 0,
                                                                            padding: 0,
                                                                            maxWidth: "100%"
                                                                        }}
                                                                    >
                                                                        <img
                                                                            alt=""
                                                                            aria-hidden="true"
                                                                            src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2716%27%20height=%2716%27/%3e"
                                                                            style={{
                                                                                display: "block",
                                                                                maxWidth: "100%",
                                                                                width: "initial",
                                                                                height: "initial",
                                                                                background: "none",
                                                                                opacity: 1,
                                                                                border: 0,
                                                                                margin: 0,
                                                                                padding: 0
                                                                            }}
                                                                        />
                                                                    </span>
                                                                    <img
                                                                        alt=""
                                                                        src="https://cdn.javisx.com/image/95e50a55-5758-48dd-b41f-a3c12635ee43.png"
                                                                        decoding="async"
                                                                        data-nimg="intrinsic"
                                                                        style={{
                                                                            position: "absolute",
                                                                            inset: 0,
                                                                            boxSizing: "border-box",
                                                                            padding: 0,
                                                                            border: "none",
                                                                            margin: "auto",
                                                                            display: "block",
                                                                            width: 0,
                                                                            height: 0,
                                                                            minWidth: "100%",
                                                                            maxWidth: "100%",
                                                                            minHeight: "100%",
                                                                            maxHeight: "100%"
                                                                        }}
                                                                    />
                                                                </span>

                                                            </span>

                                                        </div>
                                                    </div>

                                                    {/* error message */}
                                                    {touched && !this.isValid() && rawDigits.length > 0 && (
                                                        <div
                                                            className="flex justify-start items-start pt-1 gap-2 text-[0.6rem] xs:text-xs"
                                                            style={{ color: "rgb(220, 53, 69)" }}
                                                        >
                                                            <span>กรุณากรอกเบอร์โทรศัพท์ของท่าน</span>
                                                        </div>
                                                    )}
                                                </div>
                                                {this.isValid() && (
                                                    <div className="flex flex-col items-center mt-4 gap-3">
                                                        <div>
                                                            <div>
                                                                <input
                                                                    type="hidden"
                                                                    name="cf-turnstile-response"
                                                                    id="cf-chl-widget-l5ym0_response"
                                                                />
                                                            </div>
                                                        </div>
                                                        <button onClick={(e) => {
                                                            this.nexttap(e)
                                                        }} className="Register_buttonLoginSuccess__WTUG3" type="button">
                                                            ขั้นตอนถัดไป
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="w-full flex flex-row" />
                                        </form>
                                    </div>
                                    <div className="w-full flex justify-center items-center py-4">
                                        <div
                                            className="w-full flex justify-center items-center"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            <button type="button" href={this.state.linelink} onClick={() => window.open(this.state.linelink, "_blank")}>
                                                <div className="flex gap-1">
                                                    <div className="font-[400] text-[11px] leading-[13px] text-[#909090]">
                                                        พบปัญหาการใช้งาน ติดต่อเจ้าหน้าที่
                                                    </div>
                                                    <div className="font-[700] text-[11px] leading-[13px] text-transparent bg-clip-text bg-gradient-to-b from-[#E1D4B4] to-[#B7A47C]">
                                                        <div className="bg-gradient-to-b from-[#E1D4B4] to-[#B7A47C] bg-[length:100%_0.7px] bg-no-repeat bg-bottom">
                                                            คลิก
                                                        </div>
                                                    </div>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </main>
                            <main className="flex-1 overflow-y-auto flex flex-col justify-start no-scrollbar pb-24 z-40" style={{ display: tabselect == 2 ? "" : "none" }}>
                                <div className="max-w-md w-full min-h-full mx-auto pt-2 flex flex-col justify-start items-center gap-2 bg-[#101010]">
                                    <div className="w-full h-[48px] flex items-center px-2 py-3">
                                        <div>
                                            <button className="flex items-center" type="button" onClick={(e) => {
                                                this.setState({ tabselect: 1 })
                                            }}>
                                                <div className=" relative w-[32px] h-[32px] md:w-[36px] md:h-[36px] ">
                                                    <span
                                                        style={{
                                                            boxSizing: "border-box",
                                                            display: "block",
                                                            overflow: "hidden",
                                                            width: "initial",
                                                            height: "initial",
                                                            background: "none",
                                                            opacity: 1,
                                                            border: 0,
                                                            margin: 0,
                                                            padding: 0,
                                                            position: "absolute",
                                                            inset: 0
                                                        }}
                                                    >
                                                        <img
                                                            src="https://play.aroms168.win/images/back.png"
                                                            decoding="async"
                                                            data-nimg="fill"
                                                            style={{
                                                                filter: "hue-rotate(191deg) brightness(1)",
                                                                position: "absolute",
                                                                inset: 0,
                                                                boxSizing: "border-box",
                                                                padding: 0,
                                                                border: "none",
                                                                margin: "auto",
                                                                display: "block",
                                                                width: 0,
                                                                height: 0,
                                                                minWidth: "100%",
                                                                maxWidth: "100%",
                                                                minHeight: "100%",
                                                                maxHeight: "100%"
                                                            }}
                                                        />
                                                    </span>
                                                </div>
                                            </button>
                                        </div>
                                        <div className="flex-grow text-center mr-8 font-bold text-[17px] md:text-[25px] leading-[21px]">
                                            ยืนยันสมัครสมาชิก
                                        </div>
                                    </div>
                                    <div className="w-full px-3 pt-2">
                                        <div>
                                            <div
                                                className="w-full flex flex-col gap-2"
                                                style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                            >
                                                <div className="w-full relative z-0 flex flex-row justify-around">
                                                    <span className="w-8 h-8 relative z-10 flex justify-center items-center font-semibold text-base border text-white border-[#EE5F28] bg-[#EE5F28] rounded-full">
                                                        1
                                                    </span>
                                                    <span className="w-8 h-8 relative z-10 flex justify-center items-center font-semibold text-base border rounded-full text-white border-[#EE5F28] bg-[#EE5F28]">
                                                        2
                                                    </span>
                                                    <div className="w-3/6 h-0.5 absolute z-0 top-[50%] bg-[#EE5F28]" />
                                                </div>
                                                <div className="w-full relative z-0 flex flex-row justify-around">
                                                    <span className="w-full flex justify-center items-center text-white text-[0.6rem] xs:text-xs font-normal">
                                                        กรอกเบอร์โทรศัพท์
                                                    </span>
                                                    <span className="w-full flex justify-center items-center text-center text-[0.6rem] xs:text-xs font-normal text-white ">
                                                        สร้างบัญชีผู้ใช้งานข้อมูลธนาคาร
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <form autoComplete="off" role="presentation">
                                            <div className="flex flex-col bg-[#161616] border-[#24221E] border border-solid rounded-lg xs:px-3 py-4">
                                                <h3
                                                    className="w-full text-xs xs:text-sm text-gold-gradient text-center font-semibold mb-4"
                                                    style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                                >
                                                    กรอกข้อมูลบัญชีของท่าน
                                                </h3>
                                                <div className="w-full flex flex-col px-2">
                                                    <div className="w-full flex flex-row items-stretch gap-2 border-b border-[#24221E] px-2 py-4">
                                                        <label className="flex items-center text-[0.6rem] xs:text-xs">
                                                            รหัสผ่าน
                                                        </label>
                                                        <div className="flex-grow flex justify-between items-center gap-2">
                                                            <input
                                                                className="flex-grow flex items-center h-6 font-medium text-right text-xs xs:text-lg placeholder:text-xs leading-[14px] bg-transparent placeholder-[#757575] bg-[#100F12] focus:outline-0"
                                                                maxLength={20}
                                                                placeholder="สร้างรหัสผ่าน"
                                                                type={showPassword ? "text" : "password"}
                                                                name="password"
                                                                value={password}
                                                                onChange={this.handlePasswordChange}
                                                                onBlur={this.handleBlur("password")}
                                                                autoComplete="new-password"
                                                            />
                                                            <button className="flex items-center w-5" type="button" onClick={() => {
                                                                this.setState({ showPassword: !showPassword })
                                                            }} >
                                                                <span
                                                                    style={{
                                                                        boxSizing: "border-box",
                                                                        display: "inline-block",
                                                                        overflow: "hidden",
                                                                        width: "initial",
                                                                        height: "initial",
                                                                        background: "none",
                                                                        opacity: 1,
                                                                        border: 0,
                                                                        margin: 0,
                                                                        padding: 0,
                                                                        position: "relative",
                                                                        maxWidth: "100%"
                                                                    }}
                                                                >
                                                                    <span
                                                                        style={{
                                                                            boxSizing: "border-box",
                                                                            display: "block",
                                                                            width: "initial",
                                                                            height: "initial",
                                                                            background: "none",
                                                                            opacity: 1,
                                                                            border: 0,
                                                                            margin: 0,
                                                                            padding: 0,
                                                                            maxWidth: "100%"
                                                                        }}
                                                                    >
                                                                        <img
                                                                            alt=""
                                                                            aria-hidden="true"
                                                                            src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2720%27%20height=%2720%27/%3e"
                                                                            style={{
                                                                                display: "block",
                                                                                maxWidth: "100%",
                                                                                width: "initial",
                                                                                height: "initial",
                                                                                background: "none",
                                                                                opacity: 1,
                                                                                border: 0,
                                                                                margin: 0,
                                                                                padding: 0
                                                                            }}
                                                                        />
                                                                    </span>
                                                                    <img
                                                                        alt=""
                                                                        src={showPassword ? "https://play.aroms168.win/images/Password2.png" : "https://play.aroms168.win/images/password.png"}
                                                                        decoding="async"
                                                                        data-nimg="intrinsic"
                                                                        style={{
                                                                            position: "absolute",
                                                                            inset: 0,
                                                                            boxSizing: "border-box",
                                                                            padding: 0,
                                                                            border: "none",
                                                                            margin: "auto",
                                                                            display: "block",
                                                                            width: 0,
                                                                            height: 0,
                                                                            minWidth: "100%",
                                                                            maxWidth: "100%",
                                                                            minHeight: "100%",
                                                                            maxHeight: "100%"
                                                                        }}
                                                                    />
                                                                </span>
                                                            </button>
                                                        </div>
                                                        {/* {showPwdError && <div className="text-red-500">{pValidationText}</div>}
                                                        {showPwdRequired && <div className="text-red-500">กรุณากรอกรหัสผ่าน</div>} */}
                                                        <span className="flex items-center" style={{ display: password.length > 0 ? "" : "none   " }}>
                                                            <span
                                                                style={{
                                                                    boxSizing: "border-box",
                                                                    display: "inline-block",
                                                                    overflow: "hidden",
                                                                    width: "initial",
                                                                    height: "initial",
                                                                    background: "none",
                                                                    opacity: 1,
                                                                    border: 0,
                                                                    margin: 0,
                                                                    padding: 0,
                                                                    position: "relative",
                                                                    maxWidth: "100%"
                                                                }}
                                                            >
                                                                <span
                                                                    style={{
                                                                        boxSizing: "border-box",
                                                                        display: "block",
                                                                        width: "initial",
                                                                        height: "initial",
                                                                        background: "none",
                                                                        opacity: 1,
                                                                        border: 0,
                                                                        margin: 0,
                                                                        padding: 0,
                                                                        maxWidth: "100%"
                                                                    }}
                                                                >
                                                                    <img
                                                                        alt=""
                                                                        aria-hidden="true"
                                                                        src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2716%27%20height=%2716%27/%3e"
                                                                        style={{
                                                                            display: "block",
                                                                            maxWidth: "100%",
                                                                            width: "initial",
                                                                            height: "initial",
                                                                            background: "none",
                                                                            opacity: 1,
                                                                            border: 0,
                                                                            margin: 0,
                                                                            padding: 0
                                                                        }}
                                                                    />
                                                                </span>
                                                                <img
                                                                    alt=""
                                                                    src={showPwdError ? "https://cdn.javisx.com/image/3b414bff-75a7-4c24-b4f6-358229e501d8.png" : pValidationText ? "" : "https://cdn.javisx.com/image/95e50a55-5758-48dd-b41f-a3c12635ee43.png"}
                                                                    decoding="async"
                                                                    data-nimg="intrinsic"
                                                                    style={{
                                                                        position: "absolute",
                                                                        inset: 0,
                                                                        boxSizing: "border-box",
                                                                        padding: 0,
                                                                        border: "none",
                                                                        margin: "auto",
                                                                        display: "block",
                                                                        width: 0,
                                                                        height: 0,
                                                                        minWidth: "100%",
                                                                        maxWidth: "100%",
                                                                        minHeight: "100%",
                                                                        maxHeight: "100%"
                                                                    }}
                                                                />
                                                            </span>
                                                        </span>

                                                    </div>
                                                    {showPwdError && <><div className="Tooltip_invalid__vGUPd " style={{ "--invalid-color": "#DC3545" }}></div>
                                                        <div className="flex justify-start items-start pt-1 gap-2 text-[0.6rem] xs:text-xs" style={{ color: "rgb(220,53,69)" }}><span>{pValidationText}</span></div></>}
                                                </div>
                                                <div className="w-full flex flex-col px-2">
                                                    <div className="w-full flex flex-row items-stretch gap-2 border-b border-[#24221E] px-2 py-4">
                                                        <label className="flex items-center text-[0.6rem] xs:text-xs">
                                                            ยืนยันรหัสผ่าน
                                                        </label>
                                                        <div className="flex-grow flex justify-between items-center gap-2">
                                                            <input
                                                                className="flex-grow flex items-center h-6 font-medium text-right text-xs xs:text-lg placeholder:text-xs leading-[14px] bg-transparent placeholder-[#757575] bg-[#100F12] focus:outline-0"
                                                                maxLength={20}
                                                                placeholder="ยืนยันรหัสผ่านอีกครั้ง"
                                                                type={showConfirm ? "text" : "password"}
                                                                name="confirmPassword"
                                                                value={confirmPassword}
                                                                onChange={this.handleConfirmChange}
                                                                onBlur={this.handleBlur("confirmPassword")}
                                                                autoComplete="new-password"
                                                            />
                                                            <button className="flex items-center w-5" type="button" onClick={() => {
                                                                this.setState({ showConfirm: !showConfirm })
                                                            }}
                                                            >
                                                                <span
                                                                    style={{
                                                                        boxSizing: "border-box",
                                                                        display: "inline-block",
                                                                        overflow: "hidden",
                                                                        width: "initial",
                                                                        height: "initial",
                                                                        background: "none",
                                                                        opacity: 1,
                                                                        border: 0,
                                                                        margin: 0,
                                                                        padding: 0,
                                                                        position: "relative",
                                                                        maxWidth: "100%"
                                                                    }}
                                                                >
                                                                    <span
                                                                        style={{
                                                                            boxSizing: "border-box",
                                                                            display: "block",
                                                                            width: "initial",
                                                                            height: "initial",
                                                                            background: "none",
                                                                            opacity: 1,
                                                                            border: 0,
                                                                            margin: 0,
                                                                            padding: 0,
                                                                            maxWidth: "100%"
                                                                        }}
                                                                    >
                                                                        <img
                                                                            alt=""
                                                                            aria-hidden="true"
                                                                            src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2720%27%20height=%2720%27/%3e"
                                                                            style={{
                                                                                display: "block",
                                                                                maxWidth: "100%",
                                                                                width: "initial",
                                                                                height: "initial",
                                                                                background: "none",
                                                                                opacity: 1,
                                                                                border: 0,
                                                                                margin: 0,
                                                                                padding: 0
                                                                            }}
                                                                        />
                                                                    </span>
                                                                    <img
                                                                        alt=""
                                                                        src={showConfirm ? "https://play.aroms168.win/images/Password2.png" : "https://play.aroms168.win/images/password.png"}
                                                                        decoding="async"
                                                                        data-nimg="intrinsic"
                                                                        style={{
                                                                            position: "absolute",
                                                                            inset: 0,
                                                                            boxSizing: "border-box",
                                                                            padding: 0,
                                                                            border: "none",
                                                                            margin: "auto",
                                                                            display: "block",
                                                                            width: 0,
                                                                            height: 0,
                                                                            minWidth: "100%",
                                                                            maxWidth: "100%",
                                                                            minHeight: "100%",
                                                                            maxHeight: "100%"
                                                                        }}
                                                                    />
                                                                </span>
                                                            </button>
                                                        </div>
                                                        {/* {showConfirmError && <div className="text-red-500">{cValidationText}</div>} */}
                                                        {/* {showConfirmRequired && <div className="text-red-500">โปรดยืนยันรหัสผ่าน</div>} */}
                                                        <span className="flex items-center" style={{ display: confirmPassword.length > 0 ? "" : "none   " }}>
                                                            <span
                                                                style={{
                                                                    boxSizing: "border-box",
                                                                    display: "inline-block",
                                                                    overflow: "hidden",
                                                                    width: "initial",
                                                                    height: "initial",
                                                                    background: "none",
                                                                    opacity: 1,
                                                                    border: 0,
                                                                    margin: 0,
                                                                    padding: 0,
                                                                    position: "relative",
                                                                    maxWidth: "100%"
                                                                }}
                                                            >
                                                                <span
                                                                    style={{
                                                                        boxSizing: "border-box",
                                                                        display: "block",
                                                                        width: "initial",
                                                                        height: "initial",
                                                                        background: "none",
                                                                        opacity: 1,
                                                                        border: 0,
                                                                        margin: 0,
                                                                        padding: 0,
                                                                        maxWidth: "100%"
                                                                    }}
                                                                >
                                                                    <img
                                                                        alt=""
                                                                        aria-hidden="true"
                                                                        src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2716%27%20height=%2716%27/%3e"
                                                                        style={{
                                                                            display: "block",
                                                                            maxWidth: "100%",
                                                                            width: "initial",
                                                                            height: "initial",
                                                                            background: "none",
                                                                            opacity: 1,
                                                                            border: 0,
                                                                            margin: 0,
                                                                            padding: 0
                                                                        }}
                                                                    />
                                                                </span>
                                                                <img
                                                                    alt=""
                                                                    src={showConfirmError ? "https://cdn.javisx.com/image/3b414bff-75a7-4c24-b4f6-358229e501d8.png" : cValidationText ? "" : "https://cdn.javisx.com/image/95e50a55-5758-48dd-b41f-a3c12635ee43.png"}
                                                                    decoding="async"
                                                                    data-nimg="intrinsic"
                                                                    style={{
                                                                        position: "absolute",
                                                                        inset: 0,
                                                                        boxSizing: "border-box",
                                                                        padding: 0,
                                                                        border: "none",
                                                                        margin: "auto",
                                                                        display: "block",
                                                                        width: 0,
                                                                        height: 0,
                                                                        minWidth: "100%",
                                                                        maxWidth: "100%",
                                                                        minHeight: "100%",
                                                                        maxHeight: "100%"
                                                                    }}
                                                                />
                                                            </span>
                                                        </span>
                                                    </div>
                                                    {showConfirmError && <><div className="Tooltip_invalid__vGUPd " style={{ "--invalid-color": "#DC3545" }}></div>
                                                        <div className="flex justify-start items-start pt-1 gap-2 text-[0.6rem] xs:text-xs" style={{ color: "rgb(220,53,69)" }}><span>{cValidationText}</span></div></>}
                                                </div>
                                                <div className="w-full flex flex-col px-2">
                                                    <div className="w-full flex flex-row items-stretch gap-2 border-b border-[#24221E] px-2 py-4">
                                                        <label className="text-[0.6rem] xs:text-xs px-2">ธนาคาร</label>
                                                        <div className="w-full flex-grow flex flex-row justify-between items-center gap-1 cursor-pointer" onClick={(e) => {
                                                            this.setState({ openbank: true })
                                                        }} >
                                                            <label style={{ display: item == null ? "" : "none" }} className="flex-grow flex justify-end px-2 font-medium text-xs xs:text-lg leading-[14px] bg-transparent placeholder-[#757575] bg-[#100F12] focus:outline-0">
                                                                <span className="text-[#757575] text-xs">
                                                                    กรุณาเลือกธนาคาร
                                                                </span>
                                                            </label>
                                                            <label style={{ display: item == null ? "none" : "" }} className="flex-grow flex justify-end px-2 font-medium text-xs xs:text-lg leading-[14px] bg-transparent placeholder-[#757575] bg-[#100F12] focus:outline-0">
                                                                <div className="flex flex-row justify-end gap-2">
                                                                    <div className="flex items-center w-[24px] h-[24px] p-[2px] border border-[#757575] rounded-full">
                                                                        <span
                                                                            style={{
                                                                                boxSizing: "border-box",
                                                                                display: "inline-block",
                                                                                overflow: "hidden",
                                                                                width: "initial",
                                                                                height: "initial",
                                                                                background: "none",
                                                                                opacity: 1,
                                                                                border: 0,
                                                                                margin: 0,
                                                                                padding: 0,
                                                                                position: "relative",
                                                                                maxWidth: "100%"
                                                                            }}
                                                                        >
                                                                            <span
                                                                                style={{
                                                                                    boxSizing: "border-box",
                                                                                    display: "block",
                                                                                    width: "initial",
                                                                                    height: "initial",
                                                                                    background: "none",
                                                                                    opacity: 1,
                                                                                    border: 0,
                                                                                    margin: 0,
                                                                                    padding: 0,
                                                                                    maxWidth: "100%"
                                                                                }}
                                                                            >
                                                                                <img
                                                                                    alt=""
                                                                                    aria-hidden="true"
                                                                                    src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2724%27%20height=%2724%27/%3e"
                                                                                    style={{
                                                                                        display: "block",
                                                                                        maxWidth: "100%",
                                                                                        width: "initial",
                                                                                        height: "initial",
                                                                                        background: "none",
                                                                                        opacity: 1,
                                                                                        border: 0,
                                                                                        margin: 0,
                                                                                        padding: 0
                                                                                    }}
                                                                                />
                                                                            </span>
                                                                            <img
                                                                                alt=""
                                                                                src={item?.img_path}
                                                                                decoding="async"
                                                                                data-nimg="intrinsic"
                                                                                className="rounded-full"
                                                                                style={{
                                                                                    position: "absolute",
                                                                                    inset: 0,
                                                                                    boxSizing: "border-box",
                                                                                    padding: 0,
                                                                                    border: "none",
                                                                                    margin: "auto",
                                                                                    display: "block",
                                                                                    width: 0,
                                                                                    height: 0,
                                                                                    minWidth: "100%",
                                                                                    maxWidth: "100%",
                                                                                    minHeight: "100%",
                                                                                    maxHeight: "100%"
                                                                                }}
                                                                            />
                                                                        </span>
                                                                    </div>
                                                                    <div className="flex flex-grow items-center text-[12px]">ธนาคาร{item?.fullname_th}</div>
                                                                </div>
                                                            </label>
                                                            <span>
                                                                <span
                                                                    style={{
                                                                        boxSizing: "border-box",
                                                                        display: "inline-block",
                                                                        overflow: "hidden",
                                                                        width: "initial",
                                                                        height: "initial",
                                                                        background: "none",
                                                                        opacity: 1,
                                                                        border: 0,
                                                                        margin: 0,
                                                                        padding: 0,
                                                                        position: "relative",
                                                                        maxWidth: "100%"
                                                                    }}
                                                                >
                                                                    <span
                                                                        style={{
                                                                            boxSizing: "border-box",
                                                                            display: "block",
                                                                            width: "initial",
                                                                            height: "initial",
                                                                            background: "none",
                                                                            opacity: 1,
                                                                            border: 0,
                                                                            margin: 0,
                                                                            padding: 0,
                                                                            maxWidth: "100%"
                                                                        }}
                                                                    >
                                                                        <img
                                                                            alt=""
                                                                            aria-hidden="true"
                                                                            src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2712%27%20height=%2712%27/%3e"
                                                                            style={{
                                                                                display: "block",
                                                                                maxWidth: "100%",
                                                                                width: "initial",
                                                                                height: "initial",
                                                                                background: "none",
                                                                                opacity: 1,
                                                                                border: 0,
                                                                                margin: 0,
                                                                                padding: 0
                                                                            }}
                                                                        />
                                                                    </span>
                                                                    <img
                                                                        alt=""
                                                                        src="https://cdn.javisx.com/image/81eb5b22-27e2-46ff-bda1-79b2ee31b7da.png"
                                                                        decoding="async"
                                                                        data-nimg="intrinsic"
                                                                        style={{
                                                                            position: "absolute",
                                                                            inset: 0,
                                                                            boxSizing: "border-box",
                                                                            padding: 0,
                                                                            border: "none",
                                                                            margin: "auto",
                                                                            display: "block",
                                                                            width: 0,
                                                                            height: 0,
                                                                            minWidth: "100%",
                                                                            maxWidth: "100%",
                                                                            minHeight: "100%",
                                                                            maxHeight: "100%"
                                                                        }}
                                                                    />
                                                                    <noscript />
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="w-full h-full flex justify-center items-center absolute z-[100] top-0 left-0 bg-black/70" style={{ display: openbank ? "" : "none" }}>
                                                        <div className="w-[333px] text-[0.6rem] xs:text-xs bg-[#161616]">
                                                            <div className="flex flex-row gap-2 items-stretch p-4 border-b border-[#24221E]">
                                                                <div className="flex flex-grow justify-center text-xs xs:text-sm font-semibold text-white">
                                                                    กรุณาเลือกธนาคาร
                                                                </div>

                                                                <button type="button" className="text-white" onClick={(e) => {
                                                                    this.setState({ openbank: false })
                                                                }}>
                                                                    ปิด
                                                                </button>
                                                            </div>
                                                            <div className="w-full px-2 pb-2 min-h-[15rem] max-h-80 sm:h-40 md:h-60 overflow-y-auto">
                                                                <ul className="flex flex-col">
                                                                    {tblbank.map((listitem, i) => (
                                                                        <li
                                                                            onClick={(e) => {
                                                                                this.radiocheck(listitem.bank_id, listitem)
                                                                            }}
                                                                            id="select-1"
                                                                            className="flex flex-row items-stretch gap-2 border-b border-[#24221E] px-2 py-2"
                                                                        >
                                                                            <div className="flex items-center">
                                                                                <span
                                                                                    style={{
                                                                                        boxSizing: "border-box",
                                                                                        display: "inline-block",
                                                                                        overflow: "hidden",
                                                                                        width: "initial",
                                                                                        height: "initial",
                                                                                        background: "none",
                                                                                        opacity: 1,
                                                                                        border: 0,
                                                                                        margin: 0,
                                                                                        padding: 0,
                                                                                        position: "relative",
                                                                                        maxWidth: "100%"
                                                                                    }}
                                                                                >
                                                                                    <span
                                                                                        style={{
                                                                                            boxSizing: "border-box",
                                                                                            display: "block",
                                                                                            width: "initial",
                                                                                            height: "initial",
                                                                                            background: "none",
                                                                                            opacity: 1,
                                                                                            border: 0,
                                                                                            margin: 0,
                                                                                            padding: 0,
                                                                                            maxWidth: "100%"
                                                                                        }}
                                                                                    >
                                                                                        <img
                                                                                            alt=""
                                                                                            aria-hidden="true"
                                                                                            src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2730%27%20height=%2730%27/%3e"
                                                                                            style={{
                                                                                                display: "block",
                                                                                                maxWidth: "100%",
                                                                                                width: "initial",
                                                                                                height: "initial",
                                                                                                background: "none",
                                                                                                opacity: 1,
                                                                                                border: 0,
                                                                                                margin: 0,
                                                                                                padding: 0
                                                                                            }}
                                                                                        />
                                                                                    </span>
                                                                                    <img
                                                                                        alt=""
                                                                                        src={listitem.img_path}
                                                                                        decoding="async"
                                                                                        data-nimg="intrinsic"
                                                                                        className="rounded-full"
                                                                                        style={{
                                                                                            position: "absolute",
                                                                                            inset: 0,
                                                                                            boxSizing: "border-box",
                                                                                            padding: 0,
                                                                                            border: "none",
                                                                                            margin: "auto",
                                                                                            display: "block",
                                                                                            width: 0,
                                                                                            height: 0,
                                                                                            minWidth: "100%",
                                                                                            maxWidth: "100%",
                                                                                            minHeight: "100%",
                                                                                            maxHeight: "100%"
                                                                                        }}
                                                                                    />
                                                                                </span>
                                                                            </div>
                                                                            <div className="flex flex-grow items-center">ธนาคาร{listitem.fullname_th}</div>
                                                                            <div className="flex items-center">
                                                                                <div className="w-5 h-5 p-[0.3rem] flex justify-center items-center rounded-full bg-black border border-white">
                                                                                    <div className={listitem.bank_id == bankselect ? "w-3 h-3 rounded-full  bg-[#EC5B28]" : "w-3 h-3 rounded-full  bg-black"} />
                                                                                </div>
                                                                            </div>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {showbankError && <> <div className="Tooltip_invalid__vGUPd " style={{ "--invalid-color": "#DC3545" }}></div>
                                                        <div className="flex justify-start items-start pt-1 gap-2 text-[0.6rem] xs:text-xs" style={{ color: "rgb(220,53,69)" }}><span>กรุณาเลือกธนาคาร</span>
                                                        </div></>
                                                    }
                                                </div>
                                                <div className="w-full flex flex-col px-2">
                                                    <div className="w-full flex items-stretch gap-2 border-b border-[#24221E] px-2 py-4">
                                                        <label className="flex items-center text-[0.6rem] xs:text-xs">
                                                            เลขที่บัญชี
                                                        </label>
                                                        <input
                                                            name="bankAccount"
                                                            value={bankAccount}
                                                            className="flex-grow h-6 font-medium text-right text-xs xs:text-lg placeholder:text-xs leading-[14px] bg-transparent placeholder-[#757575] bg-[#100F12] focus:outline-0 text-gray-500"
                                                            type="text"
                                                            onChange={this.handleInputChange}
                                                            onBlur={this.handleFieldBlur("bankAccount")}
                                                            autoComplete="new-banknumber"
                                                            aria-invalid="false"
                                                            aria-haspopup="false"
                                                            spellCheck="false"
                                                            placeholder="กรุณากรอกเลขที่บัญชีของคุณ"
                                                        />
                                                    </div>
                                                    {showbankAccountError && <> <div className="Tooltip_invalid__vGUPd " style={{ "--invalid-color": "#DC3545" }}></div>
                                                        <div className="flex justify-start items-start pt-1 gap-2 text-[0.6rem] xs:text-xs" style={{ color: "rgb(220,53,69)" }}><span>กรุณากรอกเลขที่บัญชีของคุณ</span>
                                                        </div></>
                                                    }
                                                    {showbankAccountErrorWrong && <> <div className="Tooltip_invalid__vGUPd " style={{ "--invalid-color": "#DC3545" }}></div>
                                                        <div className="flex justify-start items-start pt-1 gap-2 text-[0.6rem] xs:text-xs" style={{ color: "rgb(220,53,69)" }}><span>กรุณาตรวจสอบเลขที่บัญชีของคุณ</span>
                                                        </div></>
                                                    }
                                                </div>
                                                <div className="w-full flex flex-col px-2" style={{ display: this.state.trueaccount ? "none" : "" }}>
                                                    <div className="w-full flex items-stretch gap-2 border-b border-[#24221E] px-2 py-4">
                                                        <label className="flex items-center text-[0.6rem] xs:text-xs">
                                                            ชื่อ–นามสกุล
                                                        </label>
                                                        <input
                                                            name="bankAccountName"
                                                            value={bankAccountName}
                                                            onChange={this.handleInputChange}
                                                            onBlur={this.handleFieldBlur("bankAccountName")}
                                                            className="flex-grow h-6 font-medium text-right text-xs xs:text-lg placeholder:text-xs leading-[14px] bg-transparent placeholder-[#757575] bg-[#100F12] focus:outline-0 text-gray-500"
                                                            type="text"
                                                            autoComplete="new-banknumberName"
                                                            aria-invalid="false"
                                                            aria-haspopup="false"
                                                            spellCheck="false"
                                                            placeholder="กรุณากรอกชื่อบัญชีของคุณ"
                                                        />
                                                    </div>
                                                    {showbankAccountNameError && <> <div className="Tooltip_invalid__vGUPd " style={{ "--invalid-color": "#DC3545" }}></div>
                                                        <div className="flex justify-start items-start pt-1 gap-2 text-[0.6rem] xs:text-xs" style={{ color: "rgb(220,53,69)" }}><span>กรุณากรอกชื่อบัญชีของคุณ</span>
                                                        </div></>
                                                    }
                                                </div>
                                            </div>
                                            <div className="w-full flex flex-col px-2"
                                                style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                            >
                                                <div className="w-full flex justify-center items-stretch gap-2 pt-4">
                                                    <div
                                                        style={{ display: acceptterm ? "none" : "" }}
                                                        className="w-5 h-5 p-[0.3rem] rounded-full bg-[#161616] border border-[#757575] cursor-pointer"
                                                        onClick={() => {
                                                            this.isvalidateALL();
                                                            // this.setState({ showterm: true });
                                                        }}
                                                    >
                                                        <div className="w-full h-full rounded-full bg-[#161616]" />
                                                    </div>


                                                    <div
                                                        onClick={() => {
                                                            this.setState({ acceptterm: !this.state.acceptterm });
                                                        }}
                                                        style={{ display: acceptterm ? "" : "none" }}
                                                        className="w-5 h-5 flex justify-center items-center rounded-full bg-[#161616] border border-[#757575] cursor-pointer"
                                                    >
                                                        <div className="w-[10px] h-[10px] rounded-full bg-[#EC5B28]" />
                                                    </div>
                                                    <div className="flex gap-1">
                                                        <div className="text-[0.6rem] xs:text-[11px] pt-[3px]">
                                                            ข้าพเจ้ามีอายุครบ 20 ปีบริบูรณ์
                                                            และได้อ่านข้อกำหนดและเงื่อนไขทั่วไป
                                                        </div>
                                                        <div className="pt-[4px] font-[700] text-[11px] leading-[13px] text-transparent bg-clip-text bg-gradient-to-b from-[#E1D4B4] to-[#B7A47C]">
                                                            <div onClick={() => {
                                                                this.isvalidateALL();
                                                            }} className="cursor-pointer bg-gradient-to-b from-[#E1D4B4] to-[#B7A47C] bg-[length:100%_0.7px] bg-no-repeat bg-bottom whitespace-nowrap">
                                                                ข้อกำหนดและเงื่อนไขทั่วไป
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="h-[1px] bg-gradient-to-b from-[#EFD596] via-[#CCBC98] to-[#B7A47C] opacity-10 mx-4 my-4" />
                                            <div className="w-full flex flex-col gap-4 px-4"
                                                style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                            >

                                                <button
                                                    onClick={(e) => this.nextstep(e, 26)}
                                                    type="button"
                                                    disabled={!loadinbutton}
                                                    className={
                                                        acceptterm && loadinbutton
                                                            ? "Register_buttonLoginSuccess__WTUG3"
                                                            : "Register_buttonLoginNone__bg6u_"
                                                    }
                                                >
                                                    {!loadinbutton ? (
                                                        <>
                                                            <span
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    gap: "8px",
                                                                }}
                                                            >
                                                                <svg
                                                                    className="animate-spin"
                                                                    width="20"
                                                                    height="20"
                                                                    viewBox="0 0 50 50"
                                                                >
                                                                    <circle
                                                                        cx="25"
                                                                        cy="25"
                                                                        r="20"
                                                                        fill="none"
                                                                        stroke="white"
                                                                        strokeWidth="4"
                                                                        strokeLinecap="round"
                                                                        strokeDasharray="31.4 31.4"
                                                                    />
                                                                </svg>
                                                                <span>กำลังดำเนินการ</span>
                                                            </span>
                                                        </>

                                                    ) : (
                                                        "เสร็จสิ้น"
                                                    )}
                                                </button>

                                                <button style={{ display: acceptterm ? "" : "none" }} className="Register_buttonLoginNone__bg6u_" type="button">
                                                    ยกเลิก
                                                </button>
                                            </div>

                                        </form>
                                        <div className="absolute left-0 bottom-0 right-0 top-0 z-0 bg-black bg-opacity-75" style={{ display: this.state.showterm ? "flex" : "none" }}   >
                                            <div
                                                className="absolute top-[50%] -translate-y-[50%] mx-[10px] w-[calc(100%-20px)] max-w-3xl bg-[#161616] border-2 border-[#444444] rounded-md"
                                                style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                            >
                                                <div className=" text-center font-semibold text-transparent bg-clip-text bg-gradient-to-r from-[#E1D4B4] to-[#B7A47C] p-6 text-sm md:text-xl ">
                                                    ข้อกำหนดในการใช้งานเว็บไซต์
                                                </div>
                                                <div className="relative flex flex-col overflow-y-auto h-[280px] mx-2 no-scrollbar">
                                                    <div className=" px-4 text-sm">
                                                        <div className="w-full">
                                                            เพื่อสิทธิประโยชน์ของท่านโปรดอ่านข้อตกลงและกด "ยันยืน" เพื่อรับทราบ
                                                            <div className="py-2">
                                                                <ul className="flex flex-col">
                                                                    <li>- สมาชิกต้องมีอายุไม่ต่ำกว่า 18 ปีบริบูรณ์</li>
                                                                    <li>
                                                                        - สมาชิกต้องกรอกข้อมูลของตนเองตามความเป็นจริงทุกประการ
                                                                        หากเกิดข้อผิดพลาดทางบริษัทจะไม่รับผิดชอบทุกกรณี
                                                                    </li>
                                                                    <li>
                                                                        -สมาชิกทุกท่านต้องยอมรับในการตัดสินใจในการเดิมพันที่เกิดขึ้น
                                                                        เมื่อมีการเดิมพันไปแล้วไม่สามารถเปลี่ยนแปลงได้ทุกกรณี
                                                                    </li>
                                                                    <li>
                                                                        - ในกรณีที่บริษัทพบความผิดปกติในการเดิมพัน
                                                                        ทางบริษัทขอสงวนสิทธิ์ในการระงับยูสเซอร์เพื่อตรวจสอบและดำเนินการตามกฎของบริษัท
                                                                    </li>
                                                                    <li>
                                                                        - หากตรวจสอบพบสมาชิกมีบัญชีใช้งานมากกว่า 1 บัญชี
                                                                        บริษัทมีสิทธิ์ที่จะจะดำเนินการระงับและยึดเครดิตทุกกรณี
                                                                    </li>
                                                                    <li>
                                                                        -หากทางบริษัทเกิดข้อสงสัยในการเดิมพันและการรับสิทธิ์พิเศษที่ผิดปกติ
                                                                        สามารถระงับตรวจสอบได้ทุกเมื่อโดยไม่ต้องแจ้งให้ทราบล่วงหน้า
                                                                    </li>
                                                                    <li>
                                                                        -หากทางบริษัทตรวจสอบพบการเดิมพันโดยใช้โปรแกรมช่วยเหลือจะถือว่าเป็นการทุจริตและเป็นอันตรายต่อเว็บ
                                                                        ทางบริษัทจะยึดเครดิตทันที
                                                                    </li>
                                                                    <li>
                                                                        -ทางบริษัทจะไม่รับผิดชอบกรณีที่สมาชิกนำข้อมูลของตนเองไปให้บุคคลอื่นจนได้รับความเสียหายทางทรัพย์สินทั้งหมด
                                                                    </li>
                                                                    <li>
                                                                        - ทางบริษัทไม่อนุญาตให้นำข้อมูลบุคคลอื่นมาใช้งาน
                                                                        หากตรวจสอบพบระงับการใช้งานทันที
                                                                    </li>
                                                                    <li>
                                                                        - บริษัทจะไม่รับผิดชอบต่อความเสียหายและความสูญเสียใดๆ
                                                                        ที่เกิดขึ้นจากระบบอินเตอร์เน็ตที่ขัดข้องในขณะเดิมพัน
                                                                    </li>
                                                                    <li>
                                                                        -หากตรวจสอบพบว่ามีการฝากเงินที่ได้มาด้วยการทุจริตหรือมิชอบด้วยกฎหมายได้มาอย่างไม่ถูกต้อง
                                                                        ทางบริษัทขอสงวนสิทธิ์ในการระงับยูสเซอร์ทันที
                                                                    </li>
                                                                    <li>
                                                                        - หากตรวจสอบพบว่าท่านมีการปลอม หรือแทรกแซง
                                                                        หรือดำเนินการขั้นตอนเพื่อทำการปกปิดหรือแทรกแซงในทางใด ๆ
                                                                        ในเรื่องของ IP ในอุปกรณ์ที่ใช้ในการเข้าถึงเว็บไซต์ เช่น Virtual
                                                                        Private Network "VPN"
                                                                        ทางทีมงานขอสงวนสิทธิ์ในการระงับยูสเซอร์ทันที
                                                                    </li>
                                                                    <li>
                                                                        - การใช้บริการสงวนสิทธิ์ของบริษัทแล้ว เท่านั้น
                                                                        จึงจะถือว่าบุคคลเป็นลูกค้าของบริษัท
                                                                        บริษัทสงวนสิทธิ์ในการยอมรับหรือปฏิเสธลูกค้าได้ตลอดเวลาไม่ว่าด้วย
                                                                        เหตุผลใดก็ตาม กิจกรรมหรือการทำรายการใดๆ
                                                                        โดยบุคคลที่ไม่ถือเป็นลูกค้า จะไม่มีผลหรือเป็นโมฆะ
                                                                    </li>
                                                                    <li>
                                                                        - ทางบริษัทขอสงวนสิทธิในการหาทุกวิถีทางด้านกฎหมาย
                                                                        และในความถูกต้องด้วยประการใดๆ
                                                                        ที่เกิดการละเมิดข้อตกลงและเงื่อนไขเหล่านี้
                                                                        รวมถึงสิทธิ์ในการปฏิเสธ หรือจำกัดการเข้าถึงบริการ เว็บไซต์
                                                                        และข้อมูลเฉพาะบุคคล
                                                                        หรือกีดกั้นการเข้าถึงจากอินเตอร์เน็ตได้ทุกเวลาและเป็นดุลยพินิจอย่างเด็ดขาดจากทางเราแต่เพียงผู้เดียว
                                                                    </li>
                                                                    <li>
                                                                        -สมาชิกมีความรู้ตัวอย่างเต็มเปี่ยมของความเสี่ยงของการสูญเสียเงินในแนวทางของการใช้บริการ
                                                                    </li>
                                                                    <li>
                                                                        - สื่อทั้งหมด ได้แก่ รูปภาพ รายละเอียด ข้อมูล ภาพประกอบ
                                                                        การออกแบบ ข้อความ ซอฟต์แวร์ กราฟิก โลโก้ และสื่ออื่นๆ
                                                                        ที่ปรากฏในเว็บไซต์ห้ามบุคคลที่ไม่เกี่ยวข้องนำไปดัดแปลงแก้ไข
                                                                        หลอกลวงผู้อื่นให้ได้รับความเสียหาย
                                                                        หากตรวจสอบพบจะมีการดำเนินคดีตามกฎหมาย
                                                                    </li>
                                                                    <li>
                                                                        - คำติชม แนวคิด และข้อเสนอแนะอื่นๆ
                                                                        ทั้งหมดที่สมาชิกส่งผ่านเว็บไซต์นี้จะถือว่าเป็นข้อมูลที่ไม่ใช่ความลับและไม่มีเจ้าของ
                                                                        AROM168 สามารถเปิดเผยหรือใช้งานด้วยวัตถุประสงค์ใดก็ได้
                                                                        โดยไม่มีพันธะผูกพันในการชดเชยให้สมาชิก
                                                                        ข้อมูลส่วนบุคคลทั้งหมดที่ส่งให้ทางเว็บไซด์จะได้รับการจัดการตามนโยบายความเป็นส่วนตัว
                                                                    </li>{" "}
                                                                    <li>
                                                                        -บริษัทขอสงวนสิทธิในการแก้ไขเปลี่ยนแปลงหรือเพิ่มเติมข้อกำหนดและเงื่อนไขการใช้เว็บไซต์
                                                                        โดยไม่จำเป็นต้องบอกกล่าวล่วงหน้าและท่านยินยอมปฏิบัติตามเงื่อนไขและข้อกำหนดดังกล่าว
                                                                    </li>
                                                                    <li>
                                                                        - เดิมพันที่ผิดปกติ ใดๆ รวมถึงการใช้ปัญญาประดิษฐ์ หรือ
                                                                        "บอท"บนอินเตอร์เน็ตจะถือว่าโมฆะ โดยไม่ต้องแจ้งให้ทราบล่วงหน้า
                                                                        ความพยายามหรือการใช้ปัญญาประดิษฐ์ของสมาชิกจะส่งผลให้บัญชีถูกระงับทันที
                                                                    </li>
                                                                    <li>
                                                                        - การเดิมพันจะถือว่าถูกต้องและเป็นที่ยอมรับจากบริษัท
                                                                        เมื่อเลขธุรกรรมถูกแสดงบนหน้าจอของสมาชิกและจะปรากฏในประวัติการทำธุรกรรมของสมาชิก
                                                                    </li>
                                                                    <li>
                                                                        - ไม่อนุญาตให้เดิมพันผ่านหลังจากเวลาที่เรากำหนด
                                                                        และ/หรือเมื่อทราบผลแข่งขัน ณ
                                                                        เวลาที่สมาชิกวางเดิมพันถ้ามีเหตุผิดพลาดที่เกิดการเปิดให้เดิมพันหลังจากเริ่มแข่งขันและ/หรือ
                                                                        เมื่อทราบผลการแข่งขัน
                                                                        บริษัทขอสงวนสิทธิ์ในการปฏิเสธหรือโมฆะแต่ละการเดิมพันที่ถูกวางโดยปราศจากการอ้างอิงจากสมาชิก
                                                                        การยอมรับการเดิมพันใดๆหรือส่วนใดๆ
                                                                        จะเป็นดุลยพินิจจากบริษัทแต่เพียงผู้เดียว
                                                                    </li>
                                                                    <li>
                                                                        -ทางบริษัทขอสงวนสิทธิ์ในการระงับหรือปิดบัญชีลูกค้าเมื่อใดก็ได้หากพบว่าว่าสมาชิกได้ละเมิดข้อกำหนดใดๆในข้อตกลงนี้หรือกระทำการโกงลักลอบ
                                                                        โจมตี ทำร้าย หรือทำลายการพนันตามปกติ การชนะใดๆ /หรือการจ่ายเงิน
                                                                        รวมถึงยอดเงินในบัญชีจะถูกริบ
                                                                        ทางบริษัทขอสงวนสิทธิ์ในการระงับยูสเซอร์ทันที
                                                                    </li>
                                                                    <li>
                                                                        -ลูกค้ายอมรับว่าได้อ่านและเห็นด้วยกับนโยบายความเป็นส่วนตัวแล้วและตกลงว่า
                                                                        <br />
                                                                        *ได้ยินยอมให้มีการประมวลผลและนำข้อมูลส่วนตัวไปใช้ตามนโยบายความเป็นส่วนตัวนี้
                                                                        <br />* บริษัท อาจประมวลผล ใช้
                                                                        ถ่ายโอนหรือจัดการกับข้อมูลส่วนตัวของลูกค้าทั่วโลกด้วยวิธีใดก็ได้ที่บริษัทเลือก
                                                                    </li>
                                                                    <li>
                                                                        -
                                                                        การยอมรับข้อกำหนดและเงื่อนไขนี้ถือเป็นข้อตกลงซึ่งคุณได้ยอมรับโดยการเลือก
                                                                        "ตกลง" ในหน้านี้และทำการเข้าสู่เว็บไซต์ต่อไป
                                                                        เมื่อคุณกระทำการดังกล่าวจะถือเป็นการทำข้อตกลงที่มีผลผูกพันทางกฎหมายตามข้อกำหนดและเงื่อนไขนี้ระหว่างสมาชิกและบริษัท
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                            <p className="py-4">
                                                                ***บริษัทAROM168เป็นผู้ตัดสินเพียงผู้เดียวและคำตัดสินใจถือเป็นที่สิ้นสุด***
                                                            </p>
                                                            <p className="w-full text-center text-gold-gradient">
                                                                AROM168,เว็บที่ให้บริการคาสิโนออนไลน์เต็มรูปแบบทั้งสล็อตออนไลน์
                                                                คาสิโนสด บาคาร่าสด เกมแทงปลา เกมกีฬา ฯลฯ
                                                                <br />
                                                                ทั้งสล็อตออนไลน์ คาสิโนสด บาคาร่าสด เกมแทงปลา เกมกีฬา ฯลฯ
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className=" text-center font-semibold text-transparent bg-clip-text bg-gradient-to-r from-[#E1D4B4] to-[#B7A47C] p-6 text-sm md:text-base ">
                                                    <button
                                                        onClick={() => {
                                                            this.setState({ acceptterm: !this.state.acceptterm, showterm: false });
                                                        }}
                                                        className="w-full h-[30px] xs:h-[45px] md:h-[72px] lg:h-[91px] secondary-button text-white primary-button justify-around"
                                                        type="button"
                                                    >
                                                        ยอมรับ
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="w-full flex justify-center items-center py-4">
                                        <div
                                            className="w-full flex justify-center items-center"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            <button type="button" href={this.state.linelink} onClick={() => window.open(this.state.linelink, "_blank")}>
                                                <div className="flex gap-1">
                                                    <div className="font-[400] text-[11px] leading-[13px] text-[#909090]">
                                                        พบปัญหาการใช้งาน ติดต่อเจ้าหน้าที่
                                                    </div>
                                                    <div className="font-[700] text-[11px] leading-[13px] text-transparent bg-clip-text bg-gradient-to-b from-[#E1D4B4] to-[#B7A47C]">
                                                        <div className="bg-gradient-to-b from-[#E1D4B4] to-[#B7A47C] bg-[length:100%_0.7px] bg-no-repeat bg-bottom">
                                                            คลิก
                                                        </div>
                                                    </div>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </main>

                        </div>
                    </div>
                    <div className="fixed bottom-0 left-1/2 -translate-x-1/2 w-[428px] mx-auto z-50" />
                </div>


            </>
        );
    }
}
export default App;
